import produce from "immer"
import { PUBLISHED, ASC, TYPE_A, PROVEN_NO } from "const"
import { QidProduct } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initQidProduct: QidProduct = {
    id: null,
    companyId: null,
    name: "",
    logoId: null,
    type: TYPE_A,
    lowDemandMode: true,
    highDemandMode: false,
    continuousMode: false,
    logicSolver: false,
    provenInUse: PROVEN_NO,
    status: PUBLISHED,
}

const initQidProductState: types.QidProductState = {
    productList: {},
    productIds: [],
    productView: initQidProduct,
    productEdit: initQidProduct,

    productFolderId: null,

    sortColumn: "name",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadView: true,
    reloadEdit: true,
}

const qidProductReducer = produce((
    draft: types.QidProductState = initQidProductState,
    action: ActionTypes = null,
): types.QidProductState => {
    switch (action.type) {
        case types.QID_PRODUCT_LIST:
            draft.productList = action.productList
            return draft

        case types.QID_PRODUCT_IDS:
            draft.productIds = action.productIds
            return draft

        case types.QID_PRODUCT_VIEW:
            draft.productView = action.product
            return draft

        case types.QID_PRODUCT_EDIT:
            draft.productEdit = action.product
            return draft

        case types.QID_PRODUCT_FOLDER_ID:
            draft.productFolderId = action.folderId
            return draft

        case types.QID_PRODUCT_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.QID_PRODUCT_FILTERS:
            draft.filters = action.filters
            return draft

        case types.QID_PRODUCT_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.QID_PRODUCT_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.QID_PRODUCT_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default qidProductReducer
